import { render, staticRenderFns } from "./task_medication.vue?vue&type=template&id=0da6d467&scoped=true"
import script from "./task_medication.vue?vue&type=script&lang=js"
export * from "./task_medication.vue?vue&type=script&lang=js"
import style0 from "./task_medication.vue?vue&type=style&index=0&id=0da6d467&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da6d467",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da6d467')) {
      api.createRecord('0da6d467', component.options)
    } else {
      api.reload('0da6d467', component.options)
    }
    module.hot.accept("./task_medication.vue?vue&type=template&id=0da6d467&scoped=true", function () {
      api.rerender('0da6d467', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/task_medication.vue"
export default component.exports